import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && authService.isLogged()) {
        console.warn('Sesión expirada o token inválido. Cerrando sesión...');

        authService.logout();

        router.navigate(['/login'], {
          queryParams: { authReason: 'expired' },
        });
      }

      return throwError(() => error);
    }),
  );
};
